import type { VoiceAgentLanguage, VoiceAgentUseCase } from './types';

export const USE_CASE_OPTION_VALUES: VoiceAgentUseCase[] = [
  'initial_qualification',
  'warm_recontact',
  'meeting_confirmation',
  'cart_recovery',
  'nps_survey',
  'custom',
];

export const LANGUAGE_OPTION_VALUES: VoiceAgentLanguage[] = [
  'es_CO',
  'es_LATAM',
  'es_MX',
  'en_US',
  'pt_BR',
];
